// @ts-nocheck
import React from "react";
import { apiUrlConfig } from "../../../constants/apiUrlConfig";
import { toast } from "react-toastify";
import ApiService from "../../../services/api.service";
import { LoaderService } from "../../../services/loader.service";
import logger from "../../../utils/logger";

export default class ConfirmAction extends React.Component {
  escapeKeyCode = 27;
  enterKeyCode = 13;

  state = {};

  constructor(props) {
    super(props);
    this.apiService = ApiService.getInstance();
    this.state = {
      id: this.props.id,
      type: this.props.type,
      title: this.props.title,
      loading: false
    };
  }
  async componentDidMount() {
    window.addEventListener("keydown", this.handleKeyUp);
    const { data } = this.props;
    data && data.images[0] && this.setState({ activeScreenshot: data.images[0] });

    if (this.state.type === "COMPONENT" || this.state.type === "API") {
      this.setLoading();
    }

    if (this.state.type === "COMPONENT") {
      this.getAllFlowNameByComponentId(this.state.id);
    }
    if (this.state.type === "API") {
      this.getAllFlowNamesByApiId(this.state.id);
    }
  }

  getAllFlowNamesByApiId = id => {
    this.apiService
      .get(apiUrlConfig.apiFlowNames(id))
      .then(res => {
        if (res.success) {
          if (res.payload !== "") {
            this.setState({ title: `This API is used in ` + res.payload + ` flows. ` + this.state.title });
          }
        }
        this.resetLoading();
      })
      .catch(err => {
        logger.warn('CONFIRM_ACTION', 'Failed to get flow names by API', err);
        toast.error(err.message);
        this.resetLoading();
      });
  };

  getAllFlowNameByComponentId = id => {
    this.apiService
      .get(apiUrlConfig.flowNames(this.state.id))
      .then(res => {
        if (res.success) {
          if (res.payload !== "") {
            this.setState({ title: `This component is used in ` + res.payload + ` flows. ` + this.state.title });
          }
        }

        this.resetLoading();
      })
      .catch(err => {
        logger.warn('CONFIRM_ACTION', 'Failed to get flow names by component', err);
        toast.error(err.message);

        this.resetLoading();
      });
  };

  setLoading = () => {
    this.setState({ loading: true });
    LoaderService.showTreeComLoading();
  };

  resetLoading = () => {
    this.setState({ loading: false });
    LoaderService.hideTreeComLoading();
  };

  handleKeyUp = e => {
    if (e.keyCode === this.escapeKeyCode) {
      this.props.actionToDismiss(false);
    }
    if (e.keyCode === this.enterKeyCode) {
      this.props.actionToConfirm(true);
    }
  };

  screenshotChange(elem) {
    this.setState({ activeScreenshot: elem });
  }

  render() {
    const { actionToConfirm, actionToOkDismiss, buttons, actionToDismiss, theme, confirmText, dismissText } = this.props;
    const { activeScreenshot, loading } = this.state;
    const isLightTheme = theme === "light";

    if (loading) {
      return null;
    }

    return (
      <div>
        <div className="modal-content modern-confirm-modal">
          <div className="modal-header modern-confirm-header">
            <div className="warning-icon-wrapper">
              <svg
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="warning-icon"
              >
                <circle cx="24" cy="24" r="22" stroke="#ef4444" strokeWidth="2" fill="none"/>
                <path d="M24 14V26" stroke="#ef4444" strokeWidth="2.5" strokeLinecap="round"/>
                <circle cx="24" cy="32" r="1.5" fill="#ef4444"/>
              </svg>
            </div>
            <h3 className="modal-confirm-title">{this.state.title}</h3>
            {this.props.componentName && (
              <p className="component-name-display">Component: <strong>{this.props.componentName}</strong></p>
            )}
          </div>
          {activeScreenshot && (
            <div className="modal-body">
              <div className="screenshot-modal-wrapper">
                <img src={`${process.env.REACT_APP_SERVER_URL}/${this.state.activeScreenshot}`} alt="screenshot" />
              </div>
            </div>
          )}
          {buttons ? (
            buttons()
          ) : (
            <div className="modal-footer modern-confirm-footer">
              {this.props.data && this.props.data.images[0] && (
                <div className="screenshot-menu">
                  <select>
                    {this.props.data.images.map((elem, index) => (
                      <option key={elem} onClick={() => this.screenshotChange(elem)}>
                        screenshot {index + 1}
                      </option>
                    ))}
                  </select>
                  <button onClick={() => actionToDismiss()} className="btn btn-success" data-dismiss="modal">
                    Add new screenshot
                  </button>
                </div>
              )}
              <div className="button-group">
                {actionToDismiss && (
                  <button
                    onClick={() => actionToDismiss()}
                    className="btn btn-cancel modern-btn-cancel"
                    data-dismiss="modal"
                  >
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '8px' }}>
                      <path d="M13.5 4.5L4.5 13.5M4.5 4.5L13.5 13.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                    {dismissText || "Cancel"}
                  </button>
                )}
                {actionToConfirm && (
                  <button
                    onClick={() => actionToConfirm(true)}
                    className="btn btn-delete modern-btn-delete"
                  >
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '8px' }}>
                      <path d="M3 4.5H15M6 4.5V3C6 2.44772 6.44772 2 7 2H11C11.5523 2 12 2.44772 12 3V4.5M14 4.5V14C14 15.1046 13.1046 16 12 16H6C4.89543 16 4 15.1046 4 14V4.5H14Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                      <path d="M7.5 8V13M10.5 8V13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                    </svg>
                    {confirmText || "Delete"}
                  </button>
                )}
                {actionToOkDismiss && (
                  <button onClick={() => actionToOkDismiss()} className="btn btn-primary modern-btn-ok" data-dismiss="modal">
                    OK
                  </button>
                )}
              </div>
            </div>
          )}
        </div>
        <style>{`
          .modern-confirm-modal {
            border-radius: 12px;
            overflow: hidden;
            box-shadow: 0 20px 25px -5px rgba(0, 0, 0, ${isLightTheme ? '0.1' : '0.3'}), 0 10px 10px -5px rgba(0, 0, 0, ${isLightTheme ? '0.04' : '0.2'});
            max-width: 480px;
            margin: 0 auto;
            background: ${isLightTheme ? '#ffffff' : '#1f2937'};
          }

          .modern-confirm-header {
            background: ${isLightTheme ? 'linear-gradient(135deg, #fef2f2 0%, #ffffff 100%)' : 'linear-gradient(135deg, #374151 0%, #1f2937 100%)'};
            border-bottom: 1px solid ${isLightTheme ? '#fee2e2' : '#4b5563'};
            padding: 32px 32px 24px;
            text-align: center;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 16px;
          }

          .warning-icon-wrapper {
            margin-bottom: 8px;
            animation: scaleIn 0.3s ease-out;
          }

          @keyframes scaleIn {
            from {
              transform: scale(0.8);
              opacity: 0;
            }
            to {
              transform: scale(1);
              opacity: 1;
            }
          }

          .warning-icon {
            filter: drop-shadow(0 4px 6px rgba(239, 68, 68, 0.1));
          }

          .modal-confirm-title {
            font-size: 20px;
            font-weight: 600;
            color: ${isLightTheme ? '#1f2937' : '#f3f4f6'};
            margin: 0;
            line-height: 1.4;
          }

          .component-name-display {
            margin: 0;
            font-size: 14px;
            color: ${isLightTheme ? '#6b7280' : '#d1d5db'};
            background: ${isLightTheme ? '#f9fafb' : '#374151'};
            padding: 8px 16px;
            border-radius: 6px;
            border: 1px solid ${isLightTheme ? '#e5e7eb' : '#4b5563'};
          }

          .component-name-display strong {
            color: ${isLightTheme ? '#374151' : '#f9fafb'};
            font-weight: 600;
          }

          .modern-confirm-footer {
            padding: 24px 32px;
            background: ${isLightTheme ? '#ffffff' : '#1f2937'};
            border-top: 1px solid ${isLightTheme ? '#f3f4f6' : '#374151'};
            display: flex;
            flex-direction: column;
            gap: 16px;
          }

          .button-group {
            display: flex;
            gap: 12px;
            justify-content: center;
          }

          .modern-btn-cancel,
          .modern-btn-delete,
          .modern-btn-ok {
            padding: 12px 24px;
            border-radius: 8px;
            font-weight: 600;
            font-size: 15px;
            border: none;
            cursor: pointer;
            transition: all 0.2s ease;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            min-width: 120px;
            box-shadow: 0 1px 2px rgba(0, 0, 0, ${isLightTheme ? '0.05' : '0.2'});
          }

          .modern-btn-cancel {
            background: ${isLightTheme ? '#ffffff' : '#374151'};
            color: ${isLightTheme ? '#374151' : '#f3f4f6'};
            border: 1.5px solid ${isLightTheme ? '#d1d5db' : '#6b7280'};
          }

          .modern-btn-cancel:hover {
            background: ${isLightTheme ? '#f9fafb' : '#4b5563'};
            border-color: ${isLightTheme ? '#9ca3af' : '#9ca3af'};
            transform: translateY(-1px);
            box-shadow: 0 4px 6px rgba(0, 0, 0, ${isLightTheme ? '0.07' : '0.3'});
          }

          .modern-btn-delete {
            background: #ef4444;
            color: white;
            border: 1.5px solid #dc2626;
          }

          .modern-btn-delete:hover {
            background: #dc2626;
            border-color: #b91c1c;
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
          }

          .modern-btn-ok {
            background: #3b82f6;
            color: white;
            border: 1.5px solid #2563eb;
          }

          .modern-btn-ok:hover {
            background: #2563eb;
            border-color: #1d4ed8;
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
          }

          .modern-btn-cancel:active,
          .modern-btn-delete:active,
          .modern-btn-ok:active {
            transform: translateY(0);
          }

          .screenshot-menu {
            display: flex;
            gap: 12px;
            justify-content: center;
            padding-bottom: 12px;
            border-bottom: 1px solid ${isLightTheme ? '#f3f4f6' : '#374151'};
          }
        `}</style>
      </div>
    );
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleKeyUp);
  }
}
